export default "__VITE_ASSET__e14e68a0__"